import { defineStore } from "pinia";
import { routes } from "@/router/index";
import { getPermissions } from "@/utils/auth";
import type { RouterStore } from "./interface";
import type { AddRouteRecordRaw } from "@/router/index";

function getRoutesMeun(): AddRouteRecordRaw[] | undefined {
  if (routes && routes.length > 0) {
    const meun_list = routes.find((item: AddRouteRecordRaw) => {
      return item && item.meta && item.meta.is_meun;
    });
    if (meun_list) {
      return meun_list.children;
    }
    return [];
  }
  return [];
}

function hasPermission(params: { roles?: string[] }, roles: string[]) {
  if (params.roles) {
    return roles.some((role: string) =>
      (params.roles as string[]).includes(role)
    );
  }
  return true;
}

// 二级数据合并
function getChildMeunList(
  childRoute: IRouteListInfo[],
  roles: string[]
): IChildRouteListInfo[] {
  const child_route_list: IChildRouteListInfo[] = [];
  if (childRoute && childRoute.length > 0) {
    childRoute.forEach((childItem: IRouteListInfo) => {
      if (childItem && childItem.meta && childItem.meta.is_meun) {
        if (hasPermission(childItem.meta, roles)) {
          const childMeta = childItem.meta;
          child_route_list.push({
            id: childItem.name,
            path: childMeta.path,
            title: childMeta.title
          });
        }
      }
    });
  }
  return child_route_list;
}

// 数据合并
function getMeunListMerge(
  routeInfo: IRouteListInfo,
  roles: string[]
): IMeunListMergeProps | {} {
  if (routeInfo.meta) {
    const meta = routeInfo.meta;
    const params: IMeunListMergeProps = {
      icon: meta.icon,
      path: meta.path,
      title: meta.title,
      id: routeInfo.name
    };
    if (routeInfo["children"]) {
      params["children"] = getChildMeunList(routeInfo["children"], roles);
    }
    return params;
  }
  return {};
}

// 权限只到二级循环直接二级循环即可
function filterAsyncRoutes(
  routes: AddRouteRecordRaw[] | undefined,
  roles: string[]
) {
  const routes_list: IMeunListMergeProps[] = [];
  if (routes) {
    routes.forEach((item: any) => {
      if (item.meta && item.meta.is_meun) {
        if (hasPermission(item.meta, roles)) {
          routes_list.push(
            getMeunListMerge(item, roles) as IMeunListMergeProps
          );
        }
      }
    });
  }
  return routes_list;
}

export const useRouteStore = defineStore({
  id: "routeStore",
  state: (): RouterStore => ({
    rolesList: [],
    menuConfigList: []
  }),
  actions: {
    setRoleList(role: string[]) {
      this.rolesList = role;
    },

    generateRoutes() {
      const route_list = getRoutesMeun();
      let rolesList = this.rolesList;
      const storageRole = getPermissions();
      if (rolesList && rolesList.length <= 0) {
        rolesList = storageRole;
      }
      this.menuConfigList = filterAsyncRoutes(route_list, rolesList);
    },

    // 判断是否有当前的角色信息
    isPermission(name: string | string[], whole: boolean = false) {
      if (!name) return false;
      let rolesList = this.rolesList;
      const storageRole = getPermissions();
      if (rolesList && rolesList.length <= 0) {
        rolesList = storageRole;
      }
      if (Array.isArray(name)) {
        if (whole) {
          return name.every((item: string) => {
            return rolesList.indexOf(item) > -1;
          });
        }
        return name.some((item: string) => {
          return rolesList.indexOf(item) > -1;
        });
      }
      return rolesList.includes(name);
    }
  },
  getters: {
    getMenuConfigList: (state: RouterStore) => {
      return state.menuConfigList;
    }
  }
});
